import { render, staticRenderFns } from "./NormApply.vue?vue&type=template&id=a6cb82e2&scoped=true"
import script from "./NormApply.vue?vue&type=script&lang=js"
export * from "./NormApply.vue?vue&type=script&lang=js"
import style0 from "./NormApply.vue?vue&type=style&index=0&id=a6cb82e2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cb82e2",
  null
  
)

export default component.exports